import { IFormController, IScope } from "angular";
export class RowCommandController {
  static $inject = ["$scope"];

  constructor($scope: IRowCommandControllerScope) {
    $scope.rowCommand = (name: string, model: any, form: IFormController) => {
      const args: IRowCommandEventArgs = {
        name,
        model,
        form,
      };
      $scope.$emit("rowCommand", args);
    };
  }
}

export interface IRowCommandControllerScope extends IScope {
  rowCommand: (name: string, model: any, form: IFormController) => void;
}

export interface IRowCommandEventArgs {
  name: string;
  model: any;
  form: IFormController;
}
